import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from './useSession';

/**
 * Гард аутентификации. Сессия сбрасывается клиентом API по кодам
 * unauthenticated / no_session / session_expired — этот гард уводит на вход.
 * Контур один: портала цеха в erp_v3 нет.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const session = useSession();
  const location = useLocation();
  if (!session.token) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return <>{children}</>;
}
